import { TabMenuModule } from 'primeng/tabmenu';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ColorPickerModule } from '../angular2-color-picker/color-picker.module';
import { CommonDirectivesModule } from '../directives/common-directives.module';
import { AppUserFormComponent } from './app-user-form/app-user-form.component';
import { CircleNumberComponent } from './circle-number/circle-number.component';
import { ColorEditorComponent } from './color-editor.component';
import { ExpansionPanelComponent } from './expansion-panel/expansion-panel.component';
import { FontFamilySelectorComponent } from './font-family-selector.component';
import { FontSizeSelectorComponent } from './font-size-selector.component';
import { IframeDynamicContentComponent } from './iframe-dynamic-content/iframe-dynamic-content.component';
import { InlineMessageComponent } from './inline-message/inline-message.component';
import { InlineNoteComponent } from './inline-note/inline-note.component';
import { LoaderInlineComponent } from './loader-inline/loader.component';
import { LoaderComponent } from './loader-overlay/loader.component';
import { OnlyNumberInputComponent } from './only-number-input.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SimpleDropdownComponent } from './simple-dropdown/simple-dropdown.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerService } from './spinner/spinner.service';
import { ToolTipComponent } from './tool-tip/tool-tip/tool-tip.component';
import { UploadButtonComponent } from './upload-button/upload-button.component';
import { YesNoDropdownComponent } from './yes-no-dropdown.component';
import { Logger, Options } from '../monitoring/logger/logger';

const components = [
  AppUserFormComponent,
  CircleNumberComponent,
  ColorEditorComponent,
  ExpansionPanelComponent,
  FontFamilySelectorComponent,
  FontSizeSelectorComponent,
  IframeDynamicContentComponent,
  InlineMessageComponent,
  InlineNoteComponent,
  LoaderComponent,
  LoaderInlineComponent,
  OnlyNumberInputComponent,
  SimpleDropdownComponent,
  SpinnerComponent,
  UploadButtonComponent,
  PageNotFoundComponent,
  YesNoDropdownComponent,
  ToolTipComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TabMenuModule,
    ReactiveFormsModule,
    CommonDirectivesModule,
    ColorPickerModule,
    TranslateModule.forChild(),

  ],
  declarations: components,
  providers: [ SpinnerService, Options, Logger],
  exports: components,
  schemas: [],
})
export class CommonComponentsModule {}
